import NiceModal, { useModal } from "@ebay/nice-modal-react";
import React, { useEffect, useRef, useState } from "react";
import { ApiDataAccess } from "../../common/ApiDataAccess";
import { ModalDialog } from "../home/controls/ModalDialog";
import "./ImagesUploadModal.css";
import { useLoader } from "../../../core/Loader";
import useNotifications from "../../../core/Notifications";
import { Controller, useForm } from "react-hook-form";

export default NiceModal.create(({ tag }) => {
    const modal = useModal();
    const [loaded, setLoaded] = useState(false);
    const [uploading, setUploading] = useState(false);
    const api = new ApiDataAccess("/images");
    const [allImages, setAllImages] = useState([]);
    const loader = useLoader();

    const notifications = useNotifications();

    const {
        register,
        formState: { errors, isValid, isSubmitting },
        handleSubmit,
        control,
    } = useForm({
        defaultValues: {
            description: "",
        },
        values: "",
    });

    useEffect(() => {
        loader.start("Loading images...");
        api.get(
            "/search/size/200/index/0",
            (apiResponse) => {
                setAllImages(apiResponse.items);
                setLoaded(true);
                console.log("all images loaded", apiResponse);
                loader.stop();
            },
            (apiError) => {
                //TODO: error loading
                console.log("Cannot load images");
                loader.stop();
            }
        );
    }, []);

    const onSubmit = async (data) => {
        setUploading(true);
        var formData = new FormData();

        formData.append("filename", data.image.name);
        formData.append("description", data.image.name);
        formData.append("user", "wiki");
        formData.append("formFile", data.image);

        console.log("to upload", data);

        var response = await api.uploadAsync("/upload", formData);

        if (response.ok) {
            var result = await response.json();
            notifications.info({
                message: "File uploaded successfully.",
            });
            modal.resolve({
                id: result.id,
                description: result.description,
                url: result.url,
            });
            setUploading(false);
            modal.remove();
        } else {
            notifications.error({
                message: "Unexpected error uploading the file.",
            });
            setUploading(false);
            modal.remove();
        }
    };
    const onError = (err) => {
        console.log("invoked submit errors:::", err);
    };
    return (
        loaded && (
            <ModalDialog modal={modal} title="Image Upload" styles={{ maxWidth: "50vw" }}>
                <div className="image-upload-content">
                    <div>
                        <form onSubmit={handleSubmit(onSubmit, onError)} autoComplete="off">
                            <fieldset disabled={isSubmitting}>
                                <div>
                                    <label htmlFor="image">Select an image:</label>
                                    <Controller
                                        name="image"
                                        rules={{ required: "An image is required." }}
                                        control={control}
                                        render={({ field: { ref, name, onBlur, onChange } }) => {
                                            return (
                                                <div>
                                                    <input
                                                        ref={ref}
                                                        type="file"
                                                        id="image"
                                                        accept="image/png, image/jpeg"
                                                        multiple={false}
                                                        onBlur={onBlur}
                                                        onChange={(e) => {
                                                            console.log("fileName", e.target.files[0].name);
                                                            onChange(e.target.files[0]);
                                                        }}
                                                    />
                                                </div>
                                            );
                                        }}
                                    />
                                </div>
                                <div>
                                    <label htmlFor="image-description">Description</label>
                                    {errors.description && <span className="error-text">Description is required</span>}
                                    <input
                                        id="image-description"
                                        {...register("description", {
                                            required: true,
                                        })}
                                        className="control"
                                        type="text"
                                        placeholder="Enter description"
                                    />
                                </div>
                                {uploading ? (
                                    <div className="uploading-spinner"></div>
                                ) : (
                                    <button type="submit" className="btn btn-primary" disabled={!isValid}>
                                        Upload
                                    </button>
                                )}
                            </fieldset>
                        </form>
                        <div>Gallery</div>
                        <div className="image-upload-grid">
                            {allImages.map((image, index) => {
                                return (
                                    <div>
                                        <img
                                            key={`photo_${index}`}
                                            async
                                            src={`/images/${encodeURIComponent(image.id)}/thumbnail`}
                                            alt={image.description}
                                            title={image.description}
                                            onClick={(e) => {
                                                modal.resolve({
                                                    description: image.description,
                                                    id: image.id,
                                                    url: image.url,
                                                });
                                                modal.remove();
                                            }}
                                        />
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>
            </ModalDialog>
        )
    );
});
